/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AnnualClockQuarter } from './AnnualClockQuarter';
import {
    AnnualClockQuarterFromJSON,
    AnnualClockQuarterToJSON,
} from './AnnualClockQuarter';

/**
 * Represents a category of annual clock (e.g., for a position)
 * @export
 * @interface AnnualClockCategory
 */
export interface AnnualClockCategory {
    /**
     *
     * @type {string}
     * @memberof AnnualClockCategory
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof AnnualClockCategory
     */
    position: string;
    /**
     *
     * @type {Array<AnnualClockQuarter>}
     * @memberof AnnualClockCategory
     */
    quarters: AnnualClockQuarter[];
}

/**
 * Check if a given object implements the AnnualClockCategory interface.
 */
export function instanceOfAnnualClockCategory(value: object): value is AnnualClockCategory {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('quarters' in value) || value['quarters'] === undefined) return false;
    return true;
}

export function AnnualClockCategoryFromJSON(json: any): AnnualClockCategory {
    return AnnualClockCategoryFromJSONTyped(json, false);
}

export function AnnualClockCategoryFromJSONTyped(json: any, _: boolean): AnnualClockCategory {
    if (json == null) {
        return json;
    }
    return {

        'title': json['title'],
        'position': json['position'],
        'quarters': ((json['quarters'] as any[]).map(AnnualClockQuarterFromJSON)),
    };
}

export function AnnualClockCategoryToJSON(json: any): AnnualClockCategory {
    return AnnualClockCategoryToJSONTyped(json, false);
}

export function AnnualClockCategoryToJSONTyped(value?: AnnualClockCategory | null, _: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'title': value['title'],
        'position': value['position'],
        'quarters': ((value['quarters'] as any[]).map(AnnualClockQuarterToJSON)),
    };
}
